/// <reference path="../_all.ts" />

module search {

  SearchResultDirective.$inject = [
  ];
  export function SearchResultDirective(
  ): ng.IDirective {

    return {
      restrict: 'AE',
      scope: {
        hitTitle: '@',
        highlights: '@',
        img: '@',
        svg: '@',
      },
      templateUrl: 'search/SearchResultDirective',
      link: function (scope: ISearchResultScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {

      }
    }
  }
}